enum CampaignContactStatus {
	Pending = 10,
	Skipped = 20,
	Processed = 30,
	Delayed = 40,
	Failed = 50,
	Delivered = 60,
	Opened = 80,
	Clicked = 90,
	Unsubscribed = 95,
	MarkedAsSpam = 96,
}

export default CampaignContactStatus;